import { CircularProgress, CircularProgressProps, useTheme } from '@material-ui/core';
import React from 'react';

export type InputAdornmentProgressProps = CircularProgressProps & {
}

export function InputAdornmentProgress (props: InputAdornmentProgressProps) {
    const theme = useTheme()

    return (
        <CircularProgress color="inherit" style={{
            width: theme.spacing(2), 
            height: theme.spacing(2), 
            marginRight: theme.spacing(0.5)
        }} />
    )
}